import { AbstractProjectAdministrativeItemController } from "@/controllers/model-controllers/abstract/abstract-project-administrative-item-controller"
import { ProjectRentalIntakeItem } from "@/models/project-rental-intake-item.model"
import { type IProjectRentalIntakeItem } from "@/interfaces/api/project-rental-intake-item.interface"
import { ProjectRentalIntakeItemRepository } from "@/repositories/project-rental-intake-item.repository"
import { useProjectsRentalIntakeItemsStore } from "@/store/projects-rental-intake-items.store"
import { storeToRefs } from "pinia"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"

export class ProjectRentalIntakeItemController extends AbstractProjectAdministrativeItemController<
  ProjectRentalIntakeItem,
  IProjectRentalIntakeItem,
  ProjectRentalIntakeItemRepository
> {
  constructor() {
    const projectsRentalIntakeItemsStore = useProjectsRentalIntakeItemsStore()
    const { projectsRentalIntakeItems } = storeToRefs(projectsRentalIntakeItemsStore)
    const storeFunctionsConfig = {
      collection: projectsRentalIntakeItems
    }

    super(ProjectRentalIntakeItem, storeFunctionsConfig, new ProjectRentalIntakeItemRepository())
    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(
      ProjectRentalIntakeItem,
      projectsRentalIntakeItems
    )
  }
}
